// src/App.jsx
import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { GameProvider } from './context/GameContext';
import Lobby from './components/Lobby';
import GameBoard from './components/GameBoard';

// Initialize socket
const socket = io("https://api.kodi28.com", {
  path: "/socket.io",
  transports: ["websocket"],
  secure: true,
});

function App() {
  const [gameState, setGameState] = useState(null);

  useEffect(() => {
    const update = (data) => {
      console.log("🔁 gameUpdate received:", data);
      // Attach gameId from localStorage so components can reference it
      const gameId = localStorage.getItem("gameId");
      setGameState({ id: gameId, ...data });
    };
    socket.on('gameUpdate', update);
    return () => socket.off('gameUpdate', update);
  }, []);

  return (
    <GameProvider socket={socket} gameState={gameState}>
      <div className="min-h-screen bg-gray-100 p-4 text-center font-sans">
        <h1 className="text-3xl font-bold text-blue-600 mb-4">28 Card Game</h1>
        {/* Show Lobby when in lobby phase or no state yet */}
        {!gameState || gameState.state.phase === 'lobby'
          ? <Lobby />
          : <GameBoard />
        }
      </div>
    </GameProvider>
  );
}

export default App;
